import merge from 'deepmerge-json';

declare global {
    interface Window {
        outreach: any;
    }
}
export const eventTracking = {
    getDefaultSearchData() {

       // this.setData( DEFAULT_EVENT_DATA_CDP)
    },
    setData(data: any, key = 'outreach') {
        window.outreach = data;
    },
    update(data: any, key = 'outreach') {
        let updatedData = merge(window.outreach, (data ? data : {}))
        this.setData( updatedData)
    },
       
    }
